import { Outlet } from 'react-router-dom'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import hasFeature from 'modules/core/lib/hasFeature'

import CollectionsBootstrap from 'modules/expenses/lib/My_cardsCollectionsBootstrap'
import expensesSubscriptions, {
  SubscriptionsProvider,
} from 'modules/expenses/store/collections/subscriptions'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const ExpensesSubscriptionFetcher = ({ children }: React.PropsWithChildren) => {
  const { loading } = useAsyncData(() => {
    const promises = []
    if (hasFeature('dev_expenses_v2_addon') && !hasFeature('dev_packaging_paywalls')) {
      promises.push(expensesSubscriptions.fetch())
    }

    return Promise.all(promises)
  }, [
    location.pathname,
    hasFeature('dev_expenses_v2_addon'),
    !hasFeature('dev_packaging_paywalls'),
  ])

  return loading ? null : <>{children}</>
}

const MyCardsPage = () => {
  useAsyncData(() => {
    if (hasFeature('dev_expenses_v2_addon') && !hasFeature('dev_packaging_paywalls')) {
      return expensesSubscriptions.fetch()
    } else {
      return Promise.resolve(true)
    }
  }, [
    location.pathname,
    hasFeature('dev_expenses_v2_addon'),
    !hasFeature('dev_packaging_paywalls'),
  ])

  useEffect(() => {
    track(trackingEvents.procurement.openMyPurchaseRequests)
  }, [])

  return (
    <CollectionsBootstrap>
      <ExpensesSubscriptionFetcher>
        <SubscriptionsProvider collection={expensesSubscriptions}>
          <ResponsivePage.Body variant="full">
            <Outlet />
          </ResponsivePage.Body>
        </SubscriptionsProvider>
      </ExpensesSubscriptionFetcher>
    </CollectionsBootstrap>
  )
}

export default MyCardsPage
